import { Box, Skeleton } from "@mui/material";

const CameraSkeleton = () => {
  return (
    <Box
      className="tw-flex tw-h-full tw-w-full tw-flex-1 tw-flex-col tw-overflow-hidden tw-rounded-xl tw-bg-gtr-surface tw-text-gtr-text"
      sx={{
        width: "100%",
        flex: 1,
        borderRadius: 3,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box className="tw-flex tw-items-center tw-gap-3 tw-bg-gtr-sidebar tw-px-4 tw-py-3">
        <Skeleton variant="circular" width={36} height={36} sx={{ bgcolor: "rgba(255,255,255,0.20)" }} />
        <Box className="tw-flex-1">
          <Skeleton width="38%" sx={{ bgcolor: "rgba(255,255,255,0.24)" }} />
          <Skeleton width="24%" sx={{ bgcolor: "rgba(255,255,255,0.14)" }} />
        </Box>
      </Box>

      <Skeleton
        variant="rectangular"
        animation="wave"
        sx={{ flexGrow: 1, bgcolor: "rgba(15, 23, 42, 0.10)" }}
      />

      <Box className="tw-grid tw-grid-cols-2 tw-gap-3 tw-border-t tw-border-gtr-border/60 tw-p-4" sx={{ p: 2 }}>
        <Skeleton height={28} />
        <Skeleton height={28} />
      </Box>
    </Box>
  );
};

export default CameraSkeleton;
